<template>
  <el-dialog
    title="Jelszó módosítása"
    :visible="true"
    width="500px"
    @close="$router.replace('/my-profile')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="user"
      :rules="rules"
      ref="passwordForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="store"
    >
      <el-form-item
        prop="oldPassword"
        label="Jelenlegi jelszó"
      >
        <el-input
          v-model="user.oldPassword"
          type="password"
        />
      </el-form-item>
      <el-form-item
        prop="newPassword"
        label="Új jelszó"
      >
        <el-input
          v-model="user.newPassword"
          type="password"
        />
      </el-form-item>
      <el-form-item
        prop="newPasswordConfirm"
        label="Új jelszó mégegyszer"
      >
        <el-input
          v-model="user.newPasswordConfirm"
          type="password"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/my-profile')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="store"
        :loading="buttonLoading"
      >
        Módosítás
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        buttonLoading: false,
        user: {
          oldPassword: '',
          newPassword: '',
          newPasswordConfirm: ''
        },
        rules: {
          oldPassword: [
            { required: true, message: 'Mező megadása kötelező', trigger: 'change' }
          ],
          newPassword: [
            { required: true, message: 'Mező megadása kötelező', trigger: 'change' }
          ],
          newPasswordConfirm: [
            { required: true, message: 'Mező megadása kötelező', trigger: 'change' }
          ]
        },
      };
    },

    methods: {
      async store() {
        // if (this.user.newPassword !== this.user.newPasswordConfirm) {
        //   return this.$messageWrapper.error('A megadott új jelszavak nem egyeznek');
        // }
        this.$refs['passwordForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              await axios.put('api/users/password-update', this.user);
              this.$refs['passwordForm'].resetFields();
              this.buttonLoading = false;
              this.$router.replace('/my-profile');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      }
    },
  };
</script>
